import * as Pagination from './pagination'

export default Pagination